import React from "react";
import Styles from "./TaskView.module.css";
import type { RowProps } from "./types";

export const DefaultRow = <T extends object>({
  row,
}: RowProps<T>): React.JSX.Element => {
  const props = row.getRowProps({ className: Styles.row });

  return (
    <div
      className={props.className}
      key={props.key}
      role={props.role}
      style={props.style}
    >
      {row.cells.map((cell) => {
        const cellProps = cell.getCellProps({
          style: { width: cell.column.width },
        });
        return (
          <div
            className={`${Styles.cell} ${Styles.fontColor} ${Styles.label} ${cellProps.className}`}
            key={cellProps.key}
            role={cellProps.role}
            style={cellProps.style}
          >
            {cell.render("Cell")}
          </div>
        );
      })}
    </div>
  );
};
